import { atom } from "recoil"

export const AtomCurrentBadge3Url = atom({
    key:'ATOMCURBADGEURL3',
    default:''
})
  